<script>
  import Jobs from "@/components/jobs/Jobs.vue";
  import SearchJob from "@/components/jobs/SearchJob.vue";

  export default {
    name: "JobsList",
    data() {
      return {
        opportunity: null,
      };
    },
    head() {
      return this.$head({
        title: "Vagas | ",
      });
    },
    components: {
      Jobs,
      SearchJob,
    },
  };
</script>

<template>
  <div class="smart-group">
    <div class="container">
      <p>
        Diferente das academias tradicionais, os Studios são caracterizados pelos treinos dinâmicos e 
        com um alto padrão de qualidade, espaços modernos, além de uma entrega de excelência para os nossos alunos. 
        As marcas que formam o grupo são Race Bootcamp, que combina exercícios funcionais com tiros de corrida na esteira; 
        Vidya Studio, um ambiente que promove a saúde física e mental com Yoga e Hot Yoga; Tonus Gym, que oferece uma musculação diferente 
        das academias tradicionais, e também a Jab House, uma combinação inédita de boxe e exercícios funcionais. 
        Por aqui, prezamos por entregar a melhor experiência fitness aos nossos alunos, desde a passagem pela recepção, até o momento pós aula. 
        Quer fazer parte do nosso time e entrar no grupo que não para de crescer? 
        Então não deixe de se inscrever em nossas vagas! Boa sorte!
      </p>
    </div>
    <div class="bg"></div>
    <div class="container inscritions">
      <h2 class="text-center">
        Inscreva-se no <br />
        Banco de Talentos dos Studios:
      </h2>

      <div class="row">
        <div class="col-lg-4 col-md-4">
          <div class="inscritions_card">
            <div class="img">
              <img src="@/assets/images/smart_fit/studio1.jpg" alt="" />
            </div>

            <div class="text">
              <h3>PROFESSOR DE MUSCULAÇÃO</h3>
              <router-link
                :to="'/vagas/144074-studios-banco-de-talentos-professor-de-musculacao/inscricao'"
              >
                INSCREVA-SE
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 mt-4 mt-md-0">
          <div class="inscritions_card">
            <div class="img">
              <img src="@/assets/images/smart_fit/studio2.jpg" alt="" />
            </div>
            <div class="text">
              <h3>RECEPCIONISTA</h3>
              <router-link
                to="/vagas/144075-studios-banco-de-talentos-recepcionista/inscricao"
              >
                INSCREVA-SE
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 mt-md-0 mt-4">
          <div class="inscritions_card">
            <div class="img">
              <img src="@/assets/images/smart_fit/studio3.jpg" alt="" />
            </div>
            <div class="text">
              <h3>AUXILIAR DE MANUTENÇÃO</h3>
              <router-link
                to="/vagas/144077-studios-banco-de-talentos-auxiliar-de-manutencao/inscricao"
              >
                INSCREVA-SE
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 mt-4">
          <div class="inscritions_card">
            <div class="img">
              <img src="@/assets/images/smart_fit/foto_yoga.png" alt="" />
            </div>
            <div class="text">
              <h3>Instrutor de Yoga</h3>
              <router-link
                to="/vagas/175944-studios-banco-de-talentos-instrutor-de-yoga/inscricao"
              >
                INSCREVA-SE
              </router-link>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
  .inscritions {
    .row {
      width: 100%;
      margin: 0 auto;
      margin-top: 3rem;
      @include media-breakpoint-down(md) {
        width: 100%;
      }
    }
  }

  .inscritions_card {
    background: #ffffff;
    box-shadow: 0px 4px 12px 8px rgba(0, 0, 0, 0.06);
    border-radius: 4px;
    border-top: 6px solid #90908d;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .text {
      width: 100%;
      padding: 2rem 4rem;
      text-align: center;
      min-height: 200px;
      text-transform: uppercase;
    }
    h3 {
      font-weight: bold;
      height: 90px;
      font-size: 2rem !important;
      text-align: center !important;
    }
    a {
      text-align: center;
      background-color: #000;
      color: #fff;
      font-size: 1.6rem;
      font-weight: 300;
      width: 100%;
      display: block;
      padding: 0.5rem 1rem;
      transition: all 0.2s ease-in-out;
      &:hover {
        background-color: theme-color(primary);
      }
    }
    .img {
      width: 100%;
      height: 200px;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }

  .smart-group {
    margin: 3rem 0px 5rem 0px;
    p {
      font-size: 1.8rem;
      color: #000;
      line-height: calc(1.8rem * 1.2);
    }
    .bg {
      height: 600px;
      overflow: hidden;
      background: url(../../assets/images/smart_fit/studiobg.jpg) no-repeat top;
      background-size: cover;
      margin-top: 3rem;
      @include media-breakpoint-down(sm) {
        height: 300px;
      }
    }
    .inscritions {
      padding: 5rem 0px;
      h2 {
        font-size: 4.3rem !important;
        font-family: "Gotham HTF" !important;
        @include media-breakpoint-down(sm) {
          font-size: 2rem !important;
        }
      }
    }
  }
</style>
